import React, { useEffect } from "react";
import * as Yup from "yup";
import FormField from "Components/Forms/FormComponent/FormFiled";
import InputFiled from "Components/Forms/InputForm/InputField";
import TextAreaInput from "Components/Forms/TextAreaForm/TextArea";
import FileUpload from "Pages/WorkInformation/FileUpload/FileUpload";
import { useState } from "react";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCheckDouble,
  faPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import axiosInstance from "../../axios";
import CustomReactSelect from "Components/Forms/ReactSelect/ReactSelect";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getDownloadURL, ref, uploadBytesResumable, deleteObject } from "firebase/storage";

import { doc, getDoc, collection, addDoc, updateDoc, arrayRemove, getDocs } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { FieldArray, Formik, Form } from "formik";

import WorkHeaderInfo from "Pages/WorkInformation/WorkHeaderInfo/WorkHeaderInfo";
import SliderUploader from "Pages/WorkInformation/FileUpload/SliderUploader";
import ImageUploader from "./ImageUploader";


const AddNewLangague = () => {
  const { t, i18n } = useTranslation(); // Initialize the useTranslation hook
  const [searchParams] = useSearchParams();
  const editId = searchParams.get("edit");
  const [documentData, setDocumentData] = useState(null);
  const [itemsOrderr, setItemsOrder] = useState([]); // Translated options

  const [firstImage, setfirstImage] = useState();
  const [secondImage, setsecondImage] = useState();
  const [BeforeImage, setBeforeImage] = useState();

  // FORM SUBMIT
  const validationSchema = Yup.object().shape({
    Name: Yup.string().required(t("required")),




  });

  const [initialValues, setInitialValues] = useState({
    Name: '',



  });
  const [Fetchloading, setFetchloading] = useState(false);
  function generateUniqueKey() {
    const timestamp = Date.now(); // Current timestamp
    const randomString = Math.random().toString(36).substring(2, 15); // Random string
    return `${timestamp}-${randomString}`;
  }
  const handleDelete = async (index) => {
    const fileToDelete = selectedFiles[index];
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);

    setSelectedFiles(updatedFiles);

    try {
      // Extract the file path and delete from Firebase Storage if it's a firebase URL
      if (fileToDelete.downloadURL && fileToDelete.downloadURL.includes("/o/")) {
        const filePath = decodeURIComponent(fileToDelete.downloadURL.split("/o/")[1].split("?")[0]);
        const storageRef = ref(storage, filePath);
        await deleteObject(storageRef);
      }

      // Remove download URL from Firestore
      const docRef = doc(db, "OurClinc", "images"); // Document path: "OurClinic/images"
      await updateDoc(docRef, {
        urls: arrayRemove(fileToDelete.downloadURL),
      });

      toast.success(t("FileDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.error(t("FileDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };


  const [City, setCity] = useState();
  const [loading, setloading] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFilesError, setSelectedFilesError] = useState(false);
  const [selectedFiles2, setSelectedFiles2] = useState([]);
  const [selectedFilesError2, setSelectedFilesError2] = useState(false);
  const [SelectedCategory, setSelectedCategory] = useState();
  const [SelectedCity, setSelectedCity] = useState();
  const [SelectedCategoryError, setSelectedCategoryError] = useState();
  const [SelectedCityError, setSelectedCityError] = useState();
  const [items, setItems] = useState(["contractor", "advisor", "provider"]); // Translated options
  const type = useSelector((state) => state.auth.type);
  
  useEffect(() => {
    if (editId) {
      const fetchLanguage = async () => {
        try {
          setFetchloading(true);
          const docRef = doc(db, "languages", "languages", "Cards", editId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setInitialValues({
              Name: data.Name || "",
            });
          }
        } catch (error) {
          console.error("Error fetching language details:", error);
        } finally {
          setFetchloading(false);
        }
      };
      fetchLanguage();
    }
  }, [editId]);

  useEffect(() => {
    const fetchExistingImages = async () => {
      try {
        const docRef = doc(db, "OurService", "services"); // Document path: "OurClinic/images"
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {

          console.log("Existing images:", docSnap.data());
          const imagesCollectionRef = collection(docRef, "Cards");
          const imagesCollectionSnap = await getDocs(imagesCollectionRef);

          imagesCollectionSnap.forEach((doc) => {
            console.log(doc.data)
            console.log(doc.id)
          });

        }
      } catch (error) {
        console.error("Error fetching existing images:", error);
      }
    };

    fetchExistingImages();
  }, []);
  // OEPN AND CLOSE MODAL
  const [showModal, setShowModalSuccess] = useState(false);
  // CLOSE MODAL
  const router = useNavigate();
  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };
  // OPEN MODAL
  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };

  // ADD CLASS ACTIVE
  const [activeItem, setActiveItem] = useState(0);

  const handleItemClick = (index) => {
    setActiveItem(index);
  };

  const handleSubmit = async (values) => {
    setloading(true);

    try {
      const collectionRef = collection(db, "languages", "languages", "Cards");

      // Filter out undefined values
      const filteredValues = Object.fromEntries(
        Object.entries({
          ...values,
        }).filter(([_, value]) => value !== undefined)
      );

      if (editId) {
        const docRef = doc(db, "languages", "languages", "Cards", editId);
        await updateDoc(docRef, filteredValues);
        toast.success("Updated successfully");
        router("/languages");
      } else {
        await addDoc(collectionRef, filteredValues);
        toast.success("Added successfully");
        setInitialValues({
          Name: '',
        });
      }
    } catch (error) {
      console.error("Error saving document:", error);
      toast.error("Failed to save document.");
    } finally {
      setloading(false);
    }
  };



  return (
    <>
      <HelmetInfo titlePage={t("addNewProject")} />{" "}
      {/* Translated page title */}
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className="project-management-request all-main">
        <div className="d-flex justify-content-end">

        </div>
        <WorkHeaderInfo
          title={editId ? "Edit Language" : "Add New Language"} // Translated section title
        />
        {/* ========== START FORM PROJECT MANAGEMENT ========== */}
        <div className="form-project-management">
          {!Fetchloading && (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ values, handleChange, handleBlur }) => (
                <Form>

                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <InputFiled
                        label={t("Name")}
                        name="Name"
                        type="text"
                        onChange={handleChange}
                        value={values.Name}
                      />
                    </div>




                    <button className="btn-main w-100" type="submit">
                      {loading ? (
                        <span className="loader"></span>
                      ) : (
                        editId ? "Edit Language" : "Add New Language"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>
        {/* ========== END FORM PROJECT MANAGEMENT ========== */}
      </div>

    </>
  );
};

export default AddNewLangague;
